import(/* webpackMode: "eager" */ "/var/www/kst-frontend-staging/app/family-safe/page.tsx")